import React, { Component } from "react";
import { signedRoundOff, getImgSrc, allSignedRoundOff } from "../../../helpers/GlobalFunctions";
import { Button } from "react-bootstrap";

export default class TSAArmPosition extends Component {
	state = {
		operativeApproach: "anatomic"
	};

	/**
	* @description function to handle change in Operative approach
	* @memberof TSAArmPosition
	*/
	/* istanbul ignore next  */
	handleOperativeApproachChange = (type) => {
		this.setState({ operativeApproach: type });
	};

	render() {
		const { operativeSide, implantTypeDropdown, armPositionData, selectedImplantType, handleImplantTypeChange } = this.props;
		const { operativeApproach } = this.state;
		const armPositionImage = operativeApproach === "anatomic" ? "shoulder_anatomic_alignment.png" : "shoulder_reverse_alignment.png";
		const selecetdArmPositionData = armPositionData?.[operativeApproach]?.[0] || null;

		return (
			<div className="dashboard-blocks">
				<div className="dashboard-blocks-body">
					<div className="card-body alignment-block">
						<div className="d-flex justify-content-between align-items-center mb-3">
							<div className="col-md-4 dashboard-block-title">Arm Position</div>
							<div className="col-md-4">
								<select id="implantType" data-testid="implantType" value={selectedImplantType} className="form-select" onChange={handleImplantTypeChange}>
									{implantTypeDropdown.map((implant, index) => <option key={`implant-type-${index}`} value={implant.name}>{implant.name}</option>)}
								</select>
							</div>
						</div>

						<div className="row align-items-center">
							<div className="col-md-8">
								<table className="table table-bordered arm-position-table">
									<thead>
										<tr>
											<th></th>
											<th>Planned</th>
											<th>Achieved</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>Acromiohumeral Distance</td>
											<td>{selecetdArmPositionData?.plannedAHD ? `${signedRoundOff(selecetdArmPositionData.plannedAHD, 1)}mm` : "N/A"}</td>
											<td>{selecetdArmPositionData?.achievedAHD ? `${signedRoundOff(selecetdArmPositionData.achievedAHD, 1)}mm` : "N/A"}</td>
										</tr>
										<tr>
											<td>Arm Length</td>
											<td>{selecetdArmPositionData?.plannedArmLength ? `${allSignedRoundOff(selecetdArmPositionData.plannedArmLength, 1)}mm` : "N/A"}</td>
											<td>{selecetdArmPositionData?.achievedArmLength ? `${allSignedRoundOff(selecetdArmPositionData.achievedArmLength, 1)}mm` : "N/A"}</td>
										</tr>
										<tr>
											<td>Lateralization</td>
											<td>{selecetdArmPositionData?.plannedLateralization ? `${allSignedRoundOff(selecetdArmPositionData.plannedLateralization, 1)}mm` : "N/A"}</td>
											<td>{selecetdArmPositionData?.achievedLateralization ? `${allSignedRoundOff(selecetdArmPositionData.achievedLateralization, 1)}mm` : "N/A"}</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div className="col-md-4 text-center">
								<img className={`w-100 arm-position-img ${operativeSide === "right" ? "flip-image" : ""}`} src={getImgSrc(armPositionImage)} alt="Arm Position" />
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-center mt-3">
						<Button variant={operativeApproach === "anatomic" ? "custom-success" : "custom-outline-success"}
							className="me-2 custom-tsa-button" onClick={() => this.handleOperativeApproachChange("anatomic")}>
							Anatomic
						</Button>
						<Button variant={operativeApproach === "reverse" ? "custom-success" : "custom-outline-success"}
							className="custom-tsa-button"
							onClick={() => this.handleOperativeApproachChange("reverse")}>
							Reverse
						</Button>
					</div>
				</div>
			</div>
		);
	}
}
